<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="status-comercial vertical-flow">
                    <h1 class="title">{{ $t("status-comercial") }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t("vendas") }}</a>
                            </li>
                            <li>
                                <a class="a-inativo">{{
                                    $t("cadastros")
                                }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    $t("status-comercial")
                                }}</a>
                            </li>
                        </ul>
                    </nav>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                    </div>

                    <div class="status-comercial-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allstatus"
                            class="data-table"
                            @sort="updateSort"
                            backend-sorting
                            backend-pagination
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :width="f.width"
                                :label="$t(f.key)"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'dias'">
                                    {{
                                        !isNaN(props.row[f.key])
                                            ? props.row[f.key]
                                            : $t(props.row[f.key])
                                    }}
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        v-if="permissao.update"
                                        :to="{
                                            name: 'edit-status-comercial',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else>
                                    <pre class="enable-line-break">{{ props.row[f.key] }}</pre>
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import StatusComercialService from "@/services/StatusComercialService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("status-comercia") &&
            to.name != "status-comerciais"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            allstatus: [],
            service: new StatusComercialService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: '15%', sortable: true },
                { key: "descricao", width: null, sortable: true },
                { key: "dias", width: '15%',sortable: false },
            ],
            debouncedOnSearch: Function,
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            deleteThis: {},
            permissao: {},
            sort: "descricao",
            order: "asc",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (
            this.$route.name.includes("status-comercia") &&
            this.$route.name != "status-comerciais"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "vendas",
            "status-comerciais"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "status-comercial" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateSort(sort, order) {
            this.sort = sort;
            this.order = order;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allstatus = value;
                    this.isEmpty = this.allstatus.length <= 0;
                    this.isLoading = false;
                })
                .catch((e) => {
                    this.isEmpty = this.allstatus.length <= 0;
                    console.error("Ocorreu algum erro: ", { e });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        selectRede(val) {
            this.$router.push(`/promotores/rede/${val.id}`);
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let statuslist = body.content.map((r) => {
                if (r.tipo != "QI" && r.tipo != "R") {
                    return {
                        id: r.idstatuscomercial,
                        codigo: r.idstatuscomercialerp,
                        descricao: r.descricao,
                        dias: r.dias,
                    };
                } else {
                    return {
                        id: r.idstatuscomercial,
                        codigo: r.idstatuscomercialerp,
                        descricao: r.descricao,
                        dias: "nao-configuravel",
                    };
                }
            });
            return statuslist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    h1.title {
        padding-top: 0px;
        margin-bottom: 0 !important;
    }

    .page {
        position: relative;
        padding-left: 0;
    }

    .status-comercial .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .status-comercial .search-and-filter .search-bar {
        width: 100%;
    }

    .status-comercial .search-and-filter .filter-bar {
        width: 31%;
    }

    .enable-line-break {
        white-space: pre-wrap;
    }
}
</style>
